import { render } from "./ComponentGlobalSearch.vue?vue&type=template&id=85f89b00&scoped=true"
import script from "./ComponentGlobalSearch.vue?vue&type=script&lang=js"
export * from "./ComponentGlobalSearch.vue?vue&type=script&lang=js"

import "./ComponentGlobalSearch.vue?vue&type=style&index=0&id=85f89b00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f89b00"]])

export default __exports__